import { render, staticRenderFns } from "./Step2-Type1-Content.vue?vue&type=template&id=165e38d0&scoped=true&"
import script from "./Step2-Type1-Content.vue?vue&type=script&lang=js&"
export * from "./Step2-Type1-Content.vue?vue&type=script&lang=js&"
import style0 from "./Step2-Type1-Content.vue?vue&type=style&index=0&id=165e38d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e38d0",
  null
  
)

export default component.exports